import gql from 'graphql-tag'
import { PaymentMethodFieldsFragment } from './paymentMethod'
import { PaymentMethodPendingFieldsFragment } from './paymentMethodPending'

export const PAYMENT_METHODS_QUERY = gql`
  query PaymentMethods($userId: Int!) {
    paymentMethod {
      ...PaymentMethodFields
    }
    paymentMethodPending(userId: $userId) {
      ...PaymentMethodPendingFields
    }
  }

  ${PaymentMethodFieldsFragment}
  ${PaymentMethodPendingFieldsFragment}
`
